import { createStore } from 'vuex';
import tournament from '@/views/Tournaments/store';

export default createStore({
  state: {
    update: false,
  },
  getters: {},
  mutations: {
    toggleUpdate(state) {
      state.update = !state.update;
    },
  },
  actions: {
    toggleUpdate({ commit }) {
      commit('toggleUpdate');
    },
  },
  modules: {
    tournament,
  },
});
